import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable from './DataTable';

function Departments() {
  const [departments, setDepartments] = useState([]);
  const [quickAddName, setQuickAddName] = useState('');
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', description: '' });

  useEffect(() => {
    fetchDepartments();
    document.title = 'Departments - Saral Asset Manager';
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await axios.get('/api/departments');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const handleQuickAdd = async (e) => {
    e.preventDefault();
    if (!quickAddName.trim()) return;
    try {
      await axios.post('/api/departments', {
        name: quickAddName.trim(),
        description: `${quickAddName.trim()} department`
      });
      setQuickAddName('');
      fetchDepartments();
    } catch (error) {
      console.error('Error adding department:', error);
      if (error.response?.status === 409) {
        alert(error.response.data.message || 'Department already exists');
      } else {
        alert('Error adding department');
      }
    }
  };

  const handleEdit = (department) => {
    setEditingDepartment(department);
    setEditForm({ name: department.name, description: department.description });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/departments/${editingDepartment.id}`, {
        ...editForm,
        id: editingDepartment.id
      });
      setEditingDepartment(null);
      fetchDepartments();
    } catch (error) {
      console.error('Error updating department:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this department?')) {
      try {
        await axios.delete(`/api/departments/${id}`);
        fetchDepartments();
      } catch (error) {
        console.error('Error deleting department:', error);
      }
    }
  };

  const columns = [
    { field: 'name', label: 'Name' },
    { field: 'description', label: 'Description' },
    { field: 'createdAt', label: 'Created At', render: (value) => new Date(value).toLocaleDateString() }
  ];

  return (
    <div className="container-fluid">
      <div className="mb-3">
        <h1 className="page-title mb-0">Departments</h1>
      </div>

      <div className="card border-0 shadow-sm mb-3">
        <div className="card-header bg-light">
          <h6 className="mb-0"><i className="fas fa-plus-circle me-2"></i>Quick Add</h6>
        </div>
        <div className="card-body">
          <form onSubmit={handleQuickAdd} className="row g-2">
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="Enter department name (e.g., IT, HR, Finance, etc.)"
                value={quickAddName}
                onChange={(e) => setQuickAddName(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-success w-100" disabled={!quickAddName.trim()}>
                <i className="fas fa-plus me-1"></i>Add
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <DataTable
            data={departments}
            columns={columns}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </div>
      </div>

      {editingDepartment && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Department</h5>
                <button type="button" className="btn-close" onClick={() => setEditingDepartment(null)}></button>
              </div>
              <form onSubmit={handleUpdate}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editForm.name}
                      onChange={(e) => setEditForm({...editForm, name: e.target.value})}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={editForm.description}
                      onChange={(e) => setEditForm({...editForm, description: e.target.value})}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setEditingDepartment(null)}>Cancel</button>
                  <button type="submit" className="btn btn-primary">Update</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Departments;